module.exports = __webpack_public_path__ + "static/media/MobileSellerboxFunction02.dd393bf6.png";